
export const SellerShopReturnsQuery = new TypedDocumentString(`
    query SellerShopReturnsQuery($handle: String!) {
  publicSeller(handle: $handle) {
    doc {
      ...SellerItem
      returnDocs {
        en {
          filename
          original
          __typename
        }
        lt {
          filename
          original
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment SellerItem on SellerDoc {
  _id
  name
  handle
  logo {
    ...Image
    __typename
  }
  __typename
}`, {"hash":"4639ec12c3f0055ce3ee586ac589df2ad9a81c10739f1e38eba33bab043436d5"});